module.exports = __webpack_public_path__ + "static/media/position.4feb58a1.svg";